export default __webpack_public_path__ + "static/bg-ai-as-a-service-df1d7d1387bd35e95d40f4749ebbc9c4.jpg";